/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import { useKeystoneSession } from '../../auth/use-keystone-session';
import { useContext } from 'react';

import { NavType } from '@state';
import { AppContext } from '@context';
import { deleteCustomerBlueprintRequest } from '@external';
import { getCanonicalDesignId } from '@helpers';

export type UseDeleteDesignParams = {
	appNav: NavType;
}
// eslint-disable-next-line max-lines-per-function
export const useDeleteDesign = (params: UseDeleteDesignParams): (designId: string) => Promise<boolean> => {
	const { getToken } = useKeystoneSession();
	const { appNav } = params;
	const { appState: { customerDesigns }} = useContext(AppContext);

	// designId is the specific design being deleted, which is NOT always appNav.designId (the currently open design) -- deleting a non-active draft tab must target that draft, not whatever is on screen.
	const deleteBp = async (designId: string): Promise<boolean> => {
		if (!appNav.email || !designId) return false;
		const design = customerDesigns.designs.find((d) => d.blueprint.id === designId);
		const submissionId = design ? getCanonicalDesignId(design.blueprint) : designId;
		const [, error] = await deleteCustomerBlueprintRequest({ email: appNav.email, submissionId, getToken });
		return error === null;
	};

	return deleteBp;
};
